import React from 'react';
import { pricing } from '../data/poolContent';
type PriceBlockProps = {
  align?: 'center' | 'start';
  size?: 'md' | 'lg';
  className?: string;
};
export function PriceBlock({
  align = 'center',
  size = 'lg',
  className = ''
}: PriceBlockProps) {
  const alignClass = align === 'center' ? 'items-center text-center' : 'items-center text-center sm:items-start sm:text-left';
  const priceSize = size === 'lg' ? 'text-6xl sm:text-7xl' : 'text-5xl sm:text-6xl';
  return <div className={`flex flex-col ${alignClass} ${className}`} data-id="element-276" data-mp="1k42ohr85s4zt">
      <p className="text-[12px] font-medium uppercase tracking-[0.14em] text-muted" data-id="element-277" data-mp="1g6equgf2zy48">
        Regular Value: <span className="line-through" data-id="element-278" data-mp="1txt9gm52txar">{pricing.regularPrice}</span>
      </p>
      <p className="mt-2 flex items-baseline gap-3" data-id="element-279" data-mp="1p4gyvfx8fr10">
        <span className="text-[11px] font-bold uppercase tracking-[0.2em] text-aqua" data-id="element-280" data-mp="1p3p1q0nzll8m">Today</span>
        <span className={`font-display font-bold leading-none text-frost-50 ${priceSize}`} data-id="element-281" data-mp="11dl1m3a0c3md">
          {pricing.today}
        </span>
        <span className="text-xs font-semibold uppercase tracking-[0.14em] text-muted" data-id="element-282" data-mp="1s09mv5kirvfd">USD</span>
      </p>
    </div>;
}